angular.module('wbDirectives').directive 'wbToggle', ['toggle', (toggle) ->
  scope: true
  restrict: 'A'
  link: ($scope, $el, $attrs) ->
    toggle.register($scope)
    toggleSelector = "[name='#{$attrs.wbToggle}']"
    $el.on 'click', toggleSelector, (e) ->
      e.stopImmediatePropagation()
      toggle.toggle($scope)
      $scope.$apply()

    $el.on 'click', $el, (e) ->
      e.stopImmediatePropagation()

    $scope.$watch 'active', (value) ->
      $el.toggleClass('active', !!value)
]
